import * as ActionTypes from './actionTypes'
import { createMultipleTabs } from '../api/saveNLdata'
import { deleteMultipleTabs } from '../api/deleteNLForm'
import { showToast } from '../../commonComponents/showToast'

//Clear form Action
export const clearForm = () => {
  return {
    type: ActionTypes.CLEAR_FORM,
  }
}
// initialize Items Form
export const initializeItemForm = (payload) => {
  return {
    type: ActionTypes.INITIALIZE_ITEMS_FORM,
    payload,
  }
}

export const createMechandiseItem = (invoiceId,merchandiseId,additionalParams={}) => {
  return {
    type: ActionTypes.CREATE_MERCHANDISE_ITEM,
    invoiceId,
    merchandiseId,
    additionalParams
  }
}
export const deleteInvoice = (invoiceId) => {
  return {
    type: ActionTypes.DELETE_INVOICE,
    invoiceId
  }
}
export const deleteMechandiseItem = (invoiceId, merchandiseId) => {
  return {
    type: ActionTypes.DELETE_MERCHANDISE_ITEM,
    invoiceId,
    merchandiseId,
  }
}
export const updateInvoiceField = (invoiceId, params) => {
  return {
    type: ActionTypes.UPDATE_INVOICE_DATA,
    invoiceId,
    ...params
  }
}

export const saveInvoiceField = (invoiceId, fieldName) => {
  return {
    type: ActionTypes.SAVE_INVOICE_DATA,
    invoiceId,
    fieldName,
  }
}

export const updateLineData = (invoiceId, merchandiseId, payload) => {
  return {
    type: ActionTypes.UPDATE_MERCH_DATA,
    invoiceId,
    merchandiseId,
    payload
  }
}

export const createInvoice=(invoiceId)=>{
  return{
    type:ActionTypes.CREATE_INVOICE,
    invoiceId
  }

}


export const addMultipleTabs = (invoiceId, merchandiseId, key, payload) => {
  return {
    type: ActionTypes.ADD_MULTIPLE_TAB,
    invoiceId,
    merchandiseId,
    key,
    payload,
  }
}
export function createMultipleTabsInItem(
  invoiceId,
  merchandiseId,
  intentExport,
  key,
  updateAddStatus
) {
  return async (dispatch) => {
    try {
      let response = await createMultipleTabs(invoiceId, merchandiseId, intentExport, key)
      if (response?.data?.eventMessage?.responseMessage) {
        let id = response?.data?.eventMessage?.responseMessage
        let payload = key === 'containers' ? { containerId: id } : { id: id }

        dispatch(addMultipleTabs(invoiceId, merchandiseId, key, payload))
      }
    } catch (err) {
      console.log('ERROR:: ' + err)
      showToast('Something went wrong, cannot create merchandise Check your network connection!')
    } finally {
      updateAddStatus()
    }
  }
}
export const deleteMultipleFields = (invoiceId, merchandiseId, key, id) => {
  return {
    type: ActionTypes.DELETE_MULTIPLE_TAB,
    invoiceId,
    merchandiseId,
    key,
    id,
  }
}
export function deleteMultipleTabsInItem(
  invoiceId,
  merchandiseId,
  intentExport,
  key,
  id,
  updateDeleteStatus
) {
  return async (dispatch) => {
    try {
      let merchResponse = await deleteMultipleTabs(invoiceId, merchandiseId, intentExport, key, id)
      if (merchResponse?.data?.eventMessage?.responseCode == '200') {
        dispatch(deleteMultipleFields(invoiceId, merchandiseId, key, id))
      } else {
        showToast('Something went wrong, cannot delete lineItem')
      }
    } catch (err) {
      console.log('ERROR:: ' + err)
      showToast('Something went wrong, cannot delete LineItem check your network connection!')
    } finally {
      updateDeleteStatus()
    }
  }
}

export const updateMultipleLineData = (invoiceId, merchandiseId, id, key, fieldName, value) => {
  return {
    type: ActionTypes.UPDATE_MULTIPLE_TAB_VALUE,
    invoiceId,
    merchandiseId,
    id,
    key,
    fieldName,
    value,
  }
}
